import styled from 'vue-styled-components'

const theme = {font: String, textGray: String}

const ThemedDateSince = styled('section', theme)`
          font-family: "${props => (props.font === 'System') ? 'Montserrat' : props.font}";
          color: ${props => props.textGray};
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 18px;
`

export default ThemedDateSince
